 const tokenKey = "token2";
const phoneKey="phone";

export function getLocalJwt() {
    return localStorage.getItem(tokenKey);
}


export function setLocalJwt(jwt) {
    localStorage.setItem(tokenKey, jwt);
}
function logout() {
    localStorage.removeItem(tokenKey);
}


export function getLocalPhone() {
    return localStorage.getItem(phoneKey);
}

export function setLocalPhone(phone) {
    localStorage.setItem(phoneKey, phone);
}



export default {
    getLocalPhone,
    setLocalPhone,

    logout,
    getLocalJwt,
    setLocalJwt,
}
